import { defineMessage } from 'services/localization';

export const messages = {
    trialOfAllFeatures: defineMessage('trial_of_all_features_for_companyname_has_expired'),
    trialOfAllFeaturesMultiple: defineMessage('trial_of_all_features_f_your_subscription_plans'),
    upgradePlan: defineMessage('upgrade_plan'),
    reviewSubscriptions: defineMessage('review_subscriptions'),
    hide: defineMessage('remind_next_week'),
};
